import * as React from 'react';

const Translated = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={25} height={24} viewBox="0 0 25 24" {...props}>
        <defs>
            <linearGradient id="translated_a" x1="50%" x2="50%" y1="100%" y2="0%">
                <stop offset="0%" stopColor="#FFF" />
                <stop offset="100%" stopColor="#F7F0ED" />
            </linearGradient>
        </defs>
        <g fill="none" fillRule="evenodd">
            <path fill="#FFF" d="M-373-6785h1920V3902H-373z" />
            <g opacity={0.4}>
                <path fill="url(#translated_a)" d="M0 0h1064v1979H0z" transform="translate(-373 -781)" />
                <g
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={1.5}
                    transform="translate(.465)"
                >
                    <path d="m19.652.748-3.75 2.25 2.25 3.75" />
                    <path d="M23.25 8.187a6.75 6.75 0 0 0-6.884-4.417M4.348 23.248l3.75-2.25-2.25-3.75" />
                    <path d="M.75 15.808a6.75 6.75 0 0 0 6.884 4.417" />
                    <rect width={12} height={12} x={0.75} y={0.748} rx={1.5} />
                    <path d="M15.75 11.248h6a1.5 1.5 0 0 1 1.5 1.5v9a1.5 1.5 0 0 1-1.5 1.5h-9a1.5 1.5 0 0 1-1.5-1.5v-6" />
                    <path d="M15.75 20.248v-4.5a1.5 1.5 0 0 1 3 0v4.5M15.75 18.748h3M6.75 3.748v1.5M3.75 5.248h6M8.25 5.248s-1.5 4.5-4.5 4.5" />
                    <path d="M6.749 8.014a3.93 3.93 0 0 0 3 1.734" />
                </g>
            </g>
        </g>
    </svg>
);
export default Translated;
